module.exports = __webpack_public_path__ + "assets/img/aquaduct.58fb1f49.jpg";